import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { getToken, clearToken } from "./lib/auth";
import { AppSidebar } from "@/components/app-shell/app-sidebar";
import { Topbar } from "@/components/app-shell/topbar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { UnsavedChangesGuard } from "@/hooks/use-unsaved-changes";

export default function App() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) navigate("/login", { replace: true });
  }, [navigate]);

  return (
    <SidebarProvider className="flex-col [--header-height:--spacing(14)]">
      <Topbar
        onSignOut={() => {
          clearToken();
          navigate("/login");
        }}
      />
      <div className="flex flex-1">
        <AppSidebar />
        <SidebarInset className="min-w-0">
          <div className="mx-auto w-full max-w-[1200px] px-4 py-5 md:px-6">
            <UnsavedChangesGuard>
              <Outlet />
            </UnsavedChangesGuard>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
